type TDisplayMessages = Record<string, string>;

interface TCombinedMessages {
  [key: string]: TDisplayMessages;
}

export interface TLangState {
  allMessages: TCombinedMessages;
  displayMessages: TDisplayMessages | undefined;
  displayLocale: string | undefined;
}

export interface TMessagesPayload {
  locale: string;
  displayMessages: TDisplayMessages;
}

export enum EAvailableLanguages {
  DE = 'de-DE',
  FR = 'fr-FR',
  EN = 'en-GB',
}

export enum ELanguageDisplayName {
  DE = 'Deutsch',
  FR = 'French',
  EN = 'English',
}
